import { useState } from "react";

export default function InfoTooltip({ content }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="relative pr-3 shrink-0">
            <button
                type="button"
                title="More information"
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                className="
                    flex items-center justify-center
                    h-5 w-5
                    min-h-5 min-w-5
                    p-0
                    border border-gray-400
                    rounded-full
                    bg-white
                    text-xs font-bold text-gray-700
                    leading-none
                    hover:bg-gray-100
                    cursor-pointer
                    select-none
                    appearance-none
                "
            >
                <span className="-mt-px">i</span>
            </button>

            {open && (
                <div
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}
                    className="
                        absolute right-0 top-full z-50 mt-2
                        w-64
                        rounded border border-gray-300
                        bg-gray-800 text-white
                        text-xs leading-snug
                        p-2 shadow-lg
                    "
                >
                    {content}
                </div>
            )}
        </div>
    );
}